module.exports = __webpack_public_path__ + "team_dark.76d6e2866296f377b275.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/team_dark.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/team_dark.svg
// module chunks = styles